import angular from 'angular';
import configureCustomerComponent from './configureCustomer.component';

let configureCustomerModule = angular.module('configureCustomer', []).component('configureCustomer', configureCustomerComponent);

export default configureCustomerModule;



// WEBPACK FOOTER //
// ./app/components/configureCustomer/configureCustomer.js